import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';

const WallpaperContent = () => (
  <Column width="100%" backgroundColor="white" spacingInset="medium">
    <Row>
      <Text type="h600">
        <FormattedMessage id="home_page.wallpaper_content.heading" />
      </Text>
    </Row>
    <Text type="b300" fontFamily="amazonEmber">
      <FormattedMessage id="home_page.wallpaper_content.body" />
    </Text>

    <Row>
      <Text type="h300">
        <FormattedMessage id="home_page.wallpaper_content.sub1.title" />
      </Text>
    </Row>
    <Text type="b300" fontFamily="amazonEmber">
      <FormattedMessage id="home_page.wallpaper_content.sub1.body" />
    </Text>

    <Row>
      <Text type="h300">
        <FormattedMessage id="home_page.wallpaper_content.sub2.title" />
      </Text>
    </Row>
    <Text type="b300" fontFamily="amazonEmber">
      <FormattedMessage id="home_page.wallpaper_content.sub2.body" />
    </Text>

    <Row>
      <Text type="h300">
        <FormattedMessage id="home_page.wallpaper_content.sub3.title" />
      </Text>
    </Row>
    <Text type="b300" fontFamily="amazonEmber">
      <FormattedMessage id="home_page.wallpaper_content.sub3.body" />
    </Text>
  </Column>
);

export default WallpaperContent;
